export const setSubscription = (subscription) => {
  return {
    type: 'SET_SUBSCRIPTION',
    payload: subscription
  };
};